import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const SculptIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M22.4854 1.51465C21.7803 0.808549 20.8458 0.425249 19.8438 0.450649C18.8458 0.470149 17.9229 0.884249 17.2452 1.61665L8.8907 10.6465C8.6513 10.9051 8.6408 11.282 8.8291 11.5644L6.8317 13.5615L1.6393 17.455C1.0944 17.8643 0.805299 18.5126 0.866799 19.1913C0.927799 19.869 1.3282 20.4559 1.9366 20.7598L6.0709 22.8272C6.3521 22.9678 6.6515 23.0352 6.9469 23.0352C7.5582 23.0352 8.1515 22.746 8.5294 22.2167L10.8795 18.9286C11.3629 18.2519 11.36 17.3641 10.9064 16.7001L12.4364 15.1701C12.5613 15.2533 12.6995 15.3085 12.8444 15.3085C13.0265 15.3085 13.2101 15.2421 13.3537 15.1093L22.384 6.75435C23.1164 6.07665 23.5305 5.15375 23.55 4.15575C23.5695 3.15815 23.1915 2.22025 22.4854 1.51465ZM9.3398 16.1455C9.0468 16.4385 9.0468 16.9131 9.3393 17.206L9.6108 17.4776C9.7666 17.6338 9.7866 17.8759 9.6577 18.0567L7.3086 21.3447C7.1797 21.5254 6.9409 21.5849 6.7412 21.4853L2.6069 19.4179C2.4048 19.3174 2.3672 19.1318 2.3603 19.0567C2.3534 18.9815 2.3574 18.792 2.5385 18.6552L7.7739 14.7294C7.8027 14.7089 7.8296 14.6855 7.8545 14.6601L9.8697 12.6449L11.3552 14.1301L9.3398 16.1455ZM21.3643 5.65385L12.8643 13.5185L10.4815 11.1357L18.3467 2.63525C18.7442 2.20505 19.2862 1.96195 19.8731 1.95015C19.8868 1.95015 19.9014 1.94965 19.9161 1.94965C20.4864 1.94965 21.0206 2.17085 21.4249 2.57515C21.839 2.98975 22.0616 3.54045 22.0499 4.12695C22.0382 4.71285 21.7949 5.25535 21.3643 5.65385Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

SculptIcon.displayName = 'SculptIcon';
